import { render } from "./TransportPage.vue?vue&type=template&id=0abac188&ts=true"
import script from "./TransportPage.vue?vue&type=script&lang=ts"
export * from "./TransportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__